export const en = {
  causeAwarenessDates: {
    national_blood_donor_month: 'National Blood Donor Month',
    mentoring_month: 'Mentoring Month',
    international_day_education: 'International Day of Education',
    black_history_month: 'Black History Month',
    world_cancer_day: 'World Cancer Day',
    international_day_women_science:
      'International Day of Women and Girls in Science',
    world_day_social_justice: 'World Day of Social Justice',
    womens_history_month: "Women's History Month",
    national_nutrition_month: 'National Nutrition Month',
    read_across_america_day: 'Read Across America Day',
    world_wildlife_day: 'World Wildlife Day',
    international_womens_day: "International Women's Day",
    global_recycling_day: 'Global Recycling Day',
    autism_acceptance_month: 'Autism Acceptance Month',
    world_health_day: 'World Health Day',
    microvolunteering_day: 'Microvolunteering Day',
    national_environmental_education_week:
      'National Environmental Education Week',
    national_volunteer_week: 'National Volunteer Week',
    earth_day: 'Earth Day',
    speech_hearing_month: 'Speech and Hearing Month',
    asian_heritage_month: 'Asian Heritage Month',
    physical_fitness_month: 'National Physical Fitness and Sports Month',
    mental_health_month: 'Mental Health Month',
    clean_air_month: 'Clean Air Month',
    mental_health_week: 'Mental Health Week',
    international_day_families: 'International Day of Families',
    global_accessibility_day: 'Global Accessibility Awareness Day',
    world_hunger_day: 'World Hunger Day',
    lgbt_pride_month: 'LGBT Pride Month',
    indigenous_history_month: 'Indigenous History Month',
    canadian_environment_week: 'Canadian Environment Week',
    world_environment_day: 'World Environment Day',
    national_trails_day: 'National Trails Day',
    world_oceans_day: 'World Oceans Day',
    world_blood_donor_day: 'World Blood Donor Day',
    juneteenth: 'Juneteenth',
    world_refugee_day: 'World Refugee Day',
    national_indigenous_peoples_day: "National Indigenous Peoples' Day",
    disabilities_pride_month: 'Disabilities Pride Month',
    clean_beaches_week: 'Clean Beaches Week',
    international_indigenous_peoples_day:
      "International Day of the World's Indigenous Peoples",
    international_youth_day: 'International Youth Day',
    world_humanitarian_day: 'World Humanitarian Day',
    womens_equality_day: "National Women's Equality Day",
    overdose_awareness_day: 'International Overdose Awareness Day',
    national_recovery_month: 'National Recovery Month',
    international_charity_day: 'International Day of Charity',
    international_literacy_day: 'International Literacy Day',
    world_suicide_prevention_day: 'World Suicide Prevention Day',
    hispanic_heritage_month: 'National Hispanic Heritage Month',
    world_cleanup_day: 'World Clean-up Day',
    international_peace_day: 'International Day of Peace',
    public_lands_day: 'National Public Lands Day',
    food_loss_waste_day: 'International Day of Awareness of Food Loss & Waste',
    orange_shirt_day: 'Orange Shirt Day',
    uk_black_history_month: 'Black History Month',
    disability_employment_month:
      'National Disability Employment Awareness Month',
    womens_history_month_ca: "Women's History Month",
    international_older_persons_day: 'International Day of Older Persons',
    world_animal_day: 'World Animal Day',
    mental_illness_week: 'Mental Illness Awareness Week',
    world_habitat_day: 'World Habitat Day',
    world_mental_health_day: 'World Mental Health Day',
    international_day_girl: 'International Day of the Girl',
    indigenous_peoples_day: "Indigenous Peoples' Day",
    disaster_reduction_day: 'International Day for Disaster Reduction',
    world_food_day: 'World Food Day',
    poverty_eradication_day: 'International Day for the Eradication of Poverty',
    native_american_heritage_month: 'Native American Heritage Month',
    homeless_youth_month: 'National Homeless Youth Awareness Month',
    career_development_month: 'National Career Development Month',
    hunger_homelessness_week: 'Hunger and Homelessness Awareness Week',
    philanthropy_day: 'National Philanthropy Day',
    universal_children_day: "Universal Children's Day",
    survivors_suicide_loss_day: 'International Survivors of Suicide Loss Day',
    giving_tuesday: 'Giving Tuesday',
    international_day_disabilities:
      'International Day of People with Disabilities',
    international_volunteer_day: 'International Volunteer Day',
    world_soil_day: 'World Soil Day',
    human_rights_day: 'Human Rights Day',
  },
}
